import React, { useEffect, useRef } from 'react';

import { FLIGHTS_COMPONENT_ID } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';
import FlightsList from '../../../containers/Flights/FlightsList';

import { FiltersPanelMobile } from '../../FlightsFilterPanel';

import EmptyFlights from '../EmptyFlights';

import type { PropsFromRedux } from '.';
import ShowFiltersButton from '../ShowFiltersButton';

const baseCls = 'checkout-flights';

export const Flights = (props: PropsFromRedux): JSX.Element => {
  const { showEmptyFlightsSkeleton, showFiltersModal } = props;

  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (window.location.hash === '#redirect_flights' && ref) {
      ref.current?.scrollIntoView();
    }
  }, [ref]);

  return (
    <div id={FLIGHTS_COMPONENT_ID} className={baseCls} ref={ref}>
      {!showEmptyFlightsSkeleton ? (
        <>
          <FlightsList />
          {showFiltersModal ? <FiltersPanelMobile /> : null}
          <ShowFiltersButton />
        </>
      ) : (
        <EmptyFlights />
      )}
    </div>
  );
};
